import { isEmpty } from 'lodash';
import React, { useState, memo } from 'react';
import styled from 'styled-components';

import Button from '../../../Button';
import ClientOrderListSkeleton from '../../Clients/ClientOrderListSkeleton';
import OrderCard from '../OrderCard';

import { ORDER_STATUSES as STATUSES } from '../OrderStatus/constants';
import { IOrderCard } from '../OrderCard/OrderCard';

interface IOrderCardList {
  className?: string;
  isLoading?: boolean;
  orders?: IOrderCard[];
  visible?: number;
  attachable?: boolean;
  detachable?: boolean;
  onAttachTicket?: IOrderCard['onAttachTicket'];
  onClickOrderId: IOrderCard['onClickOrderId'];

  // TODO: добавить тип при типизации тикета
  activeTicket?: any;
}

const OrderCardList = ({
  isLoading = true,
  orders = [],
  visible = 5,
  attachable = false,
  onClickOrderId = () => null,
  detachable = false,
  activeTicket = null,
  onAttachTicket = () => null,
  ...props
}: IOrderCardList) => {
  const [isExpand, setIsExpand] = useState(false);

  if (isLoading) {
    return <StyledListSkeleton />;
  }

  if (isEmpty(orders)) {
    return null;
  }

  const headline = `Заказы клиента · ${orders.length}`;
  const hasHidden = orders.length > visible;
  const shownOrders = isExpand ? orders : orders.slice(0, visible);

  return (
    <StyledOrderCardList {...props}>
      <StyledHeadline>{headline}</StyledHeadline>
      <StyledList>
        {shownOrders.map(order => (
          <StyledOrderCard
            key={order.id}
            onClickOrderId={onClickOrderId}
            activeTicket={activeTicket}
            attachable={attachable}
            detachable={detachable}
            onAttachTicket={onAttachTicket}
            {...order}
          />
        ))}
      </StyledList>
      {!isExpand && hasHidden && (
        <StyledShowMoreButton functional onClick={setIsExpand}>
          Показать все заказы
        </StyledShowMoreButton>
      )}
    </StyledOrderCardList>
  );
};

const StyledOrderCardList = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledOrderCard = styled(OrderCard)`
  padding: 10px;
`;

const StyledHeadline = styled.div`
  color: #919499;
  flex-shrink: 0;
  font-size: 12px;
  height: 23px;
  line-height: 23px;
  padding: 0 10px;
`;

const StyledList = styled.div`
  flex-grow: 1;
`;

const StyledListSkeleton = styled(ClientOrderListSkeleton)`
  padding: 7px 10px;
`;

const StyledShowMoreButton = styled(Button)`
  color: #007aff;
  font-size: 12px;
  padding: 0 10px;
  text-align: left;
`;

export default memo(OrderCardList);
